export function getVideoFrame(videoElement?: HTMLVideoElement) {
  if (!videoElement) return '';

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (context) {
    const [w, h] = [videoElement.videoWidth, videoElement.videoHeight];
    canvas.width = w / 2;
    canvas.height = h / 2;
    context.drawImage(videoElement, 0, 0, w / 2, h / 2);
    const { data } = context.getImageData(canvas.width / 2, canvas.height / 2, 1, 1);

    // discard if image is blank
    if (data[0] === 0 && data[1] === 0 && data[2] === 0) {
      return '';
    }

    const base64ImageData = canvas.toDataURL('image/jpeg', 1.0);
    return base64ImageData;
  } else {
    return '';
  }
}
